import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { TechnicalFeature } from 'src/app/models';
import { ProductsTechnicalFeaturesAddComponent } from '../../../products-technical-features/products-technical-features-add/products-technical-features-add.component';
import { GenericResource } from 'src/app/resources';

@Component({
    selector: 'app-technical-features-add',
    templateUrl: './technical-features-add.component.html',
    styleUrl: './technical-features-add.component.sass',
    standalone: false
})
export class TechnicalFeaturesAddComponent extends GenericCrudAddComponent<TechnicalFeature> {

  featuresRes?: GenericResource<TechnicalFeature>;

  createTechnicalFeatureComponent = ProductsTechnicalFeaturesAddComponent;

  override async preFetch(): Promise<void> {
    this.featuresRes = this.api.resources.product.technicalfeatures;
  }

  override initFormGroup(): FormGroup<any> {
    const group = this.fb.group({
      technicalFeatureId: [undefined],
    });
    return group;
  }

}
